var map = {
	"./glove_anis.png": "VSR+",
	"./glove_argent.png": "sTyT",
	"./glove_betterave.png": "cNJT",
	"./glove_bleu_marine.png": "at6Q",
	"./glove_brique.png": "X7Vo",
	"./glove_camel.png": "VhWU",
	"./glove_canard.png": "eGna",
	"./glove_chanel.png": "pl9u",
	"./glove_clematite.png": "OumC",
	"./glove_corrida.png": "yDvF",
	"./glove_emeraude.png": "NDba",
	"./glove_flanelle.png": "cBji",
	"./glove_gitane.png": "FZKL",
	"./glove_gris_perle.png": "e9LS",
	"./glove_laurier.png": "JZ/3",
	"./glove_marron_fonce.png": "eVv7",
	"./glove_new_brique.png": "HrLr",
	"./glove_noir.png": "Vwnt",
	"./glove_none.png": "+Nl3",
	"./glove_ocre.png": "1gbl",
	"./glove_perrier.png": "6DOg",
	"./glove_poil_chameau.png": "FFOP",
	"./glove_rose_indien.png": "fN37",
	"./glove_tilleul.png": "vRJF"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "mFJH";


//////////////////
// WEBPACK FOOTER
// ./src/assets/colors/women ^\.\/glove_.*\.png$
// module id = mFJH
// module chunks = 0